import PropTypes from 'prop-types';
import React, { Fragment, useState } from 'react';
import { Form, Radio, Button, Label } from 'semantic-ui-react';
import Select from 'react-select';
import countryList from 'react-select-country-list';
import { map } from 'lodash';
import config from './../../../config/config.json';
const { marketingAppHost } = config[process.env.REACT_APP_DIST_ENV];
import VATRates from 'vatrates';

import * as styles from './SignupForm.less';

const fieldOffset = { marginBottom: 10 };

const businessTypes = [
  'SaaS / Software',
  'Media / Publishing',
  'Ecommerce',
  'Professional services',
  'Other',
];

const SignupStepOne = props => {
  const {
    values,
    handleChange,
    handleBlur,
    errors,
    touched,
    nextStep,
    disabled,
  } = props;
  const vatRates = new VATRates();
  const countries = countryList().getData();
  const [country, setCountry] = useState(values.country);

  const countryHandler = value => {
    values.country = value;
    setCountry(values.country);
  };

  return (
    <Fragment>
      <Form.Field>
        <label>1. What's your work email address?</label>
      </Form.Field>
      <Form.Field className={styles.formField}>
        <Form.Input
          name='email'
          type='text'
          value={values.email || ''}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </Form.Field>
      <Form.Field>
        {errors.email && touched.email && (
          <div className={styles.validationErrorWrapper}>
            <Label
              className={styles.validationError}
              color='red'
              basic
              pointing
            >
              {errors.email}
            </Label>
          </div>
        )}
      </Form.Field>
      <Form.Field>
        <label>2. Country:</label>
      </Form.Field>
      <Form.Field className={styles.formField}>
        <Select
          options={countries}
          value={country || {}}
          onChange={countryHandler}
        />
      </Form.Field>
      {vatRates.isVATCountry(country.value) && (
        <>
          <Form.Field>
            <label>If you have a VAT nr, enter it here:</label>
          </Form.Field>
          <Form.Field className={styles.formField}>
            <Form.Input
              name='businessVatNumber'
              type='text'
              value={values.businessVatNumber || ''}
              onChange={handleChange}
              onBlur={handleBlur}
            />
          </Form.Field>
        </>
      )}
      <Form.Field>
        {errors.businessVatNumber && touched.businessVatNumber && (
          <div className={styles.validationErrorWrapper}>
            <Label
              className={styles.validationError}
              color='red'
              basic
              pointing
            >
              {errors.businessVatNumber}
            </Label>
          </div>
        )}
      </Form.Field>
      <Form.Field>
        <label>3. What's your business type?</label>
      </Form.Field>
      {map(businessTypes, (el, key) => (
        <Form.Field style={fieldOffset} key={key}>
          <Radio
            label={el}
            name='businessType'
            value={el}
            id={el}
            className={styles.inputRadio}
            checked={values.businessType === el}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </Form.Field>
      ))}
      <Form.Field>
        {errors.businessType && touched.businessType && (
          <div className={styles.validationErrorWrapper}>
            <Label
              className={styles.validationError}
              color='red'
              basic
              pointing
            >
              {errors.businessType}
            </Label>
          </div>
        )}
      </Form.Field>
      <Form.Field>
        <Button
          onClick={nextStep}
          disabled={disabled}
          className={styles.signUpButton}
        >
          Continue
        </Button>
      </Form.Field>
      <span className={styles.footerText}>
        By signing up you agree to our{' '}
        <a href={`${marketingAppHost}/terms`}>Terms & conditions</a> and{' '}
        <a href={`${marketingAppHost}/privacy`}>Privacy Policy</a>
      </span>
    </Fragment>
  );
};

export default SignupStepOne;

SignupStepOne.propTypes = {
  values: PropTypes.object,
  touched: PropTypes.object,
  errors: PropTypes.object,
  isDirty: PropTypes.bool,
  disabled: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  handleSubmit: PropTypes.func,
  nextStep: PropTypes.func,
  setFieldValue: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/views/components/SignupForm/SignupStepOne.js